import { IDataStorage } from '../internal/data-storage';
import { InternalIndex } from '../internal/internal-index';
import { InternalTable } from '../internal/internal-table';

export class Doctor implements IDataStorage {
  index: InternalIndex = new InternalIndex('Id', 'Id', true, false);
  tableDefinition: InternalTable = new InternalTable('Doctors', 'Id', true, [
    this.index
  ]);

  Id: number;
  ReferenceId: string;
  Name: string;
  Title: string;
  TelephoneNumber: string;
  PracticeNumber: string;

  static getTableDefinition(): InternalTable {
    return new Doctor().tableDefinition;
  }
}
